import React from 'react';
import styles from './css/InlineSpinner.module.css';

interface InlineSpinnerProps {
    size?: 'default' | 'small';
}

const InlineSpinner: React.FC<InlineSpinnerProps> = ({ size = 'default' }) => (
    <div className={styles.spinnerOverlay}>
        <div className={size === 'small' ? styles.spinnerSmall : styles.spinner}></div>
    </div>
);

export default React.memo(InlineSpinner);
